import './textField.scoped.scss'
import { ChangeEvent, FocusEvent, ReactNode } from "react"
import { TextInput, TextInputProps } from "components/common/formFields/textInput/textInput"
import { FieldLabel } from "components/common/formFields/fieldLabel/fieldLabel"

export interface TextFieldProps {
  label: string | ReactNode
  hint?: string
  name: string
  value: string | number
  isInvalid: boolean
  errors?: string
  onChange: (event: ChangeEvent) => void
  onBlur: (event: FocusEvent) => void
  type?: TextInputProps["type"]
  autoComplete?: string
  autoFocus?: boolean
  inputMode?: TextInputProps["inputMode"]
}

export const TextField = (props: TextFieldProps) => {
  return (
    <label className="select-field column">
      <FieldLabel label={props.label} hint={props.hint} />
      <TextInput
        name={props.name}
        value={props.value}
        onChange={props.onChange}
        onBlur={props.onBlur}
        isInvalid={props.isInvalid}
        errors={props.errors}
        type={props.type}
        autoComplete={props.autoComplete}
        autoFocus={props.autoFocus}
        inputMode={props.inputMode}
      />
    </label>
  )
}

